"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSessionContext = exports.SessionContext = void 0;
const makeContextAndHook_1 = require("../utils/makeContextAndHook");
/**
 * @internal
 */
_a = (0, makeContextAndHook_1.makeContextAndHook)('SessionContext'), exports.SessionContext = _a[0], exports.useSessionContext = _a[1];
//# sourceMappingURL=SessionContext.js.map